import { useMemo } from 'react';
import { useAppSelector } from '../../store.model';
import { getAllDevicesIds } from '../selectors';
import { useGroups } from '../../groups/hooks/useGroups';
import { CommanderAPI } from '../api/CommanderAPI';
import { skipToken } from '@reduxjs/toolkit/query';
import { orComparator } from '../../../util/lodash/orComparator';
import _ from 'lodash';
import { GroupAPI } from '../../groups/api/GroupAPI';

/**
 * Use redux to get and fetch device
 * @param deviceId usually is the queryParam
 * @param onError callback when call fail
 * @returns
 */
export const useAllDevices = () => {
  const { data: groups, ...restGroups } = GroupAPI.useGetGroupsQuery(undefined);
  const { data: associatedDevices, ...restAssociatedDevices } =
    CommanderAPI.useGetAssociatedDevicesQuery(null);
  const devicesIds = useAppSelector(getAllDevicesIds);
  const { data: devices, ...restDevices } =
    CommanderAPI.useGetCommandersByIdsQuery(devicesIds ?? skipToken, {
      skip:
        !groups ||
        !associatedDevices ||
        devicesIds === undefined ||
        devicesIds?.length === 0,
    });

  const response = useMemo(
    () =>
      _.chain({ ...restDevices, data: devices })
        .mergeWith(restGroups, orComparator)
        .mergeWith(restAssociatedDevices, orComparator)
        .value(),
    [devices, restGroups, restDevices, restAssociatedDevices]
  );

  return response;
};
